import styled from 'styled-components';
import Btn020 from 'dc/Btn020';
import Btn026 from 'dc/Btn026';
import SpaHR03 from 'dc/SpaHR03';
import SpaHR04 from 'dc/SpaHR04';
import { Typ41, Typ30 } from 'dc/Typ';

export const Container = styled.div`
  width: 458px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const Wrapper = styled.div`
  background-color: #fff;
  border-radius: 5px;
  width: 100%;
  margin-top: 50px;
  padding: 56px 77px 68px 77px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Title = styled(Typ41)`
  color: #004750;
  margin-bottom: 32px;
`;

export const RegisterWrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  background-color: transparent;
`;

export const NewUserText = styled(Typ30)`
  color: rgba(38, 50, 56, 0.7);
  max-width: 180px;
`;

export const RegisterButton = styled(Btn020)`
  background-color: transparent;
  border: 0;
  > span {
    color: #007079;
  }
`;

export const SpacerText = styled(SpaHR04)`
  width: 288px;
`;

export const SpacerLine = styled(SpaHR03)`
  width: 288px;
`;

export const LoginButton = styled(Btn026)`
  margin-bottom: 12px;
  z-index: 1;
`;
